
import React, {Component} from 'react';
import { connect } from 'react-redux';

import {initNavbarState} from 'actions/navbar.js';

const withNavigation = (WrappedComponent, navState, sideBarEnable) =>
    connect()(class extends Component {
        componentWillMount() {
            this.props.dispatch(initNavbarState(navState));
            if(sideBarEnable!==undefined) {
                this.props.dispatch({type:'SET_SIDEBAR_ENABLE', enable:sideBarEnable});
            }
        }
        render() {
            return <WrappedComponent {...this.props}/>;
        }
    });

export default withNavigation;



// WEBPACK FOOTER //
// ./src/modules/navigation/withNavigation.js